module.exports = __webpack_public_path__ + "static/media/sCreditsDark.2d49a7b6.png";